import styled from "styled-components";
export const AddTicketStyle = styled.div`
  border-radius: 5px;

  box-shadow: 0px 1px 10px #00000005;
  .ticket-card {
    background-color: ${({ theme }) => theme.box};
    .header {
      padding: 5px 10px;
      background-color: ${({ theme }) => theme.body};
    }
  }
  .file {
    padding: 7px 10px;
    border: 1px solid #b6b6b6;
    border-radius: 5px;
    margin-right: 10px;
    background-color: ${({ theme }) => theme.attach};
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    height: fit-content;
    padding: 6px 10px;
    margin-top: 8px;
  }

  .file > input[type="file"] {
    display: none;
  }

  .file > label {
    cursor: pointer;
  }

  .file > label:hover {
    border-color: hsl(0, 0%, 21%);
  }

  .file > label:active {
    background-color: hsl(0, 0%, 96%);
  }
`;
